import script from "./RealEstateSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./RealEstateSlide.vue?vue&type=script&setup=true&lang=js"

import "./RealEstateSlide.vue?vue&type=style&index=0&id=371a9125&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-371a9125"]])

export default __exports__